<div>
    @if (!(goals()?.updateGoals?.length || goals()?.newGoals?.length)) {
        <div class="modal-panel">
            <span>{{ 'flipto.components.goals.NoGoalsHaveBeenSet' | translate }}</span>
        </div>
    }

    @for (goal of goals()?.updateGoals; track goal) {
        <div
            class="modal-panel"
            [class]="{ deleted: goal.markedForRemoval, disabled: goal.isActive == 0 }"
        >
            <div class="modal-panel-actions">
                <div class="ft-dropdown" [class.active]="openMenuKey() === 'u' + $index" (click)="toggleMenu('u' + $index, $event)">
                    <a class="action ft-dropdown-toggle"><i class="ft-icn-caret-down"></i></a>
                    <ul class="ft-dropdown-menu">
                        @if (!goal.markedForRemoval && goal.isActive == 1) {
                            <li (click)="deactivate(goal)">
                                <a>{{ 'flipto.components.goals.TurnOff' | translate }}</a>
                            </li>
                        }
                        @if (!goal.markedForRemoval && goal.isActive != 1) {
                            <li (click)="activate(goal)">
                                <a>{{ 'flipto.components.goals.TurnOn' | translate }}</a>
                            </li>
                        }
                        @if (!goal.markedForRemoval) {
                            <li>
                                <a (click)="remove(goal)">{{ 'flipto.components.goals.Delete' | translate }}</a>
                            </li>
                        }
                        @if (goal.markedForRemoval) {
                            <li>
                                <a (click)="restore(goal)">{{ 'flipto.components.goals.Restore' | translate }}</a>
                            </li>
                        }
                    </ul>
                </div>
            </div>
            <div class="modal-panel-status">
                @if (goal.markedForRemoval) {
                    <span class="text-danger">{{ 'flipto.components.goals.MarkedForRemoval' | translate }}</span>
                }
            </div>

            <ft-goal-selector-ng [goal]="goal" />
            <ft-incentive-selector-ng [goal]="goal" [incentives]="incentives()" [culture]="culture()" />
        </div>
    }

    @for (goal of goals()?.newGoals; track goal) {
        <div class="modal-panel">
            <div class="modal-panel-actions">
                <div class="ft-dropdown" [class.active]="openMenuKey() === 'n' + $index" (click)="toggleMenu('n' + $index, $event)">
                    <a class="action ft-dropdown-toggle"><i class="ft-icn-caret-down"></i></a>
                    <ul class="ft-dropdown-menu">
                        @if (goal.isActive == 1) {
                            <li (click)="deactivate(goal)">
                                <a>{{ 'flipto.components.goals.TurnOff' | translate }}</a>
                            </li>
                        }
                        @if (goal.isActive != 1) {
                            <li (click)="activate(goal)">
                                <a>{{ 'flipto.components.goals.TurnOn' | translate }}</a>
                            </li>
                        }
                        <li (click)="removeNewGoal($index)">
                            <a>{{ 'flipto.components.goals.Delete' | translate }}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <ft-goal-selector-ng [goal]="goal" />
            <ft-incentive-selector-ng [goal]="goal" [incentives]="incentives()" [culture]="culture()" />
        </div>
    }

    <div class="modal-footer-align">
        <a class="ft-btn ft-btn-plus-1 ft-btn-outline-light" (click)="addNewGoal()">
            {{ 'flipto.components.goals.AddGoal' | translate }}
        </a>
    </div>
</div>
